import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from './admin/DashboardPage';
import { UsersPage } from './admin/UsersPage';
import { SubscriptionsPage } from './admin/SubscriptionsPage';
import { PlansPage } from './admin/PlansPage';
import { OrdersPage } from './admin/OrdersPage';
import { ModulesPage } from './admin/ModulesPage';
import { BetaFoundersPage } from './admin/BetaFoundersPage';
import { CMSPage } from './admin/CMSPage';
import { QAPage } from './admin/QAPage';
import { SupportPage } from './admin/SupportPage';
import { AlertsPage } from './admin/AlertsPage';
import { BackupsPage } from './admin/BackupsPage';
import { SecurityPage } from './admin/SecurityPage';
import { DiagnosticPage } from './admin/DiagnosticPage';
import { ReportsPage } from './admin/ReportsPage';
import { CRMPipelinePage } from './admin/CRMPipelinePage';
import { CRMProspectsPage } from './admin/CRMProspectsPage';
import { CRMAnalysePage } from './admin/CRMAnalysePage';
import { CRMDealsPage } from './admin/CRMDealsPage';
import { CRMOrganizationsPage } from './admin/CRMOrganizationsPage';
import { CRMInteractionsPage } from './admin/CRMInteractionsPage';
import SeoManagementPage from './admin/SeoManagementPage';
import { BlogPostsPage } from './admin/BlogPostsPage';
import { BlogEditorPage } from './admin/BlogEditorPage';
import { BlogCategoriesPage } from './admin/BlogCategoriesPage';
import { BlogTagsPage } from './admin/BlogTagsPage';

export function AdminDashboardNew() {
  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/subscriptions" element={<SubscriptionsPage />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/modules" element={<ModulesPage />} />
      <Route path="/beta-founders" element={<BetaFoundersPage />} />
      <Route path="/cms" element={<CMSPage />} />
      <Route path="/qa" element={<QAPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/alerts" element={<AlertsPage />} />
      <Route path="/backups" element={<BackupsPage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/diagnostic" element={<DiagnosticPage />} />
      <Route path="/reports" element={<ReportsPage />} />

      <Route path="/crm/pipeline" element={<CRMPipelinePage />} />
      <Route path="/crm/prospects" element={<CRMProspectsPage />} />
      <Route path="/crm/analyse" element={<CRMAnalysePage />} />
      <Route path="/crm/deals" element={<CRMDealsPage />} />
      <Route path="/crm/organizations" element={<CRMOrganizationsPage />} />
      <Route path="/crm/interactions" element={<CRMInteractionsPage />} />

      <Route path="/seo" element={<SeoManagementPage />} />

      <Route path="/blog/posts" element={<BlogPostsPage />} />
      <Route path="/blog/posts/new" element={<BlogEditorPage />} />
      <Route path="/blog/posts/:id/edit" element={<BlogEditorPage />} />
      <Route path="/blog/categories" element={<BlogCategoriesPage />} />
      <Route path="/blog/tags" element={<BlogTagsPage />} />

      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
